import { render, staticRenderFns } from "./GatedContentPage.vue?vue&type=template&id=64622ec7"
import script from "./GatedContentPage.vue?vue&type=script&lang=js"
export * from "./GatedContentPage.vue?vue&type=script&lang=js"
import style0 from "./GatedContentPage.vue?vue&type=style&index=0&id=64622ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports